const musicLinksValidationHR = {
    "add": {
        "release_name": {
            "required": "Naziv izdanja je obavezan"
        },
        "ean": {
            "required": "EAN/UPC je obavezan"
        },
        "artist_name": {
            "required": "Ime izvođača je obavezno"
        },
        "url_part1": {
            "required": "Url Dio 1 je obavezan"
        },
        "url_part2": {
            "required": "Url Dio 2 je obavezan",
            "length": "Url Dio 2 ne može biti duži od 10 znakova",
            "duplicate": "Ups! Ovaj url je već povezan s drugim glazbenim linkom. Molimo pokušajte drugi url.",
            "urlAvailable": "Url je dostupan",
            "urlInvalid": "Url je nevažeći"
        },
        "amazonmusic_url": {
            "required": "Amazon Music Url je obavezan",
            "invalid": "Molimo dodajte važeći Amazon Music Url."
        },
        "applemusic_url": {
            "required": "Apple Music Url je obavezan",
            "invalid": "Molimo dodajte važeći Apple Music Url."
        },
        "beatport_url": {
            "required": "Beatport Url je obavezan",
            "invalid": "Molimo dodajte važeći Beatport Url."
        },
        "deezer_url": {
            "required": "Deezer Url je obavezan",
            "invalid": "Molimo dodajte važeći Deezer Url."
        },
        "junodownload_url": {
            "required": "Junodownload Url je obavezan",
            "invalid": "Molimo dodajte važeći Junodownload Url."
        },
        "soundcloud_url": {
            "required": "Soundcloud Url je obavezan",
            "invalid": "Molimo dodajte važeći Soundcloud Url."
        },
        "spotify_url": {
            "required": "Spotify Url je obavezan",
            "invalid": "Molimo dodajte važeći Spotify Url."
        },
        "tidal_url": {
            "required": "Tidal Url je obavezan",
            "invalid": "Molimo dodajte važeći Tidal Url."
        },
        "traxsource_url": {
            "required": "Traxsource Url je obavezan",
            "invalid": "Molimo dodajte važeći Traxsource Url."
        },
        "youtube_url": {
            "required": "Youtube Url je obavezan",
            "invalid": "Molimo dodajte važeći Youtube Url."
        },
        "anghami_url": {
            "required": "Anghami Url je obavezan",
            "invalid": "Molimo dodajte važeći Url."
        },
        "bandcamp_url": {
            "required": "Bandcamp Url je obavezan",
            "invalid": "Molimo dodajte važeći Url."
        },
        "boomplay_url": {
            "required": "Boomplay Url je obavezan",
            "invalid": "Molimo dodajte važeći Url."
        },
        "iheartradio_url": {
            "required": "iHeartRadio Url je obavezan",
            "invalid": "Molimo dodajte važeći Url."
        },
        "jiosaavn_url": {
            "required": "JioSaavn Url je obavezan",
            "invalid": "Molimo dodajte važeći Url."
        },
        "sevendigital_url": {
            "required": "7digital Url je obavezan",
            "invalid": "Molimo dodajte važeći Url."
        },
        "other_url": {
            "invalid": "Molimo dodajte važeći Url."
        },
        "pvTrackName": {
            "required": "Naziv pjesme je obavezan"
        },
        "pvArtistName": {
            "required": "Ime izvođača je obavezno"
        }
    },
    "update": {
        "release_name": {
            "required": "Naziv izdanja je obavezan"
        },
        "ean": {
            "required": "EAN/UPC je obavezan"
        },
        "artist_name": {
            "required": "Ime izvođača je obavezno"
        },
        "url_part1": {
            "required": "Url Dio 1 je obavezan"
        },
        "url_part2": {
            "required": "Url Dio 2 je obavezan",
            "length": "Url Dio 2 ne može biti duži od 10 znakova",
            "duplicate": "Ups! Ovaj url je već povezan s drugim glazbenim linkom. Molimo pokušajte drugi url.",
            "urlAvailable": "Url je dostupan",
            "urlInvalid": "Url je nevažeći"
        },
        "amazonmusic_url": {
            "required": "Amazon Music Url je obavezan",
            "invalid": "Molimo dodajte važeći Amazon Music Url."
        },
        "applemusic_url": {
            "required": "Apple Music Url je obavezan",
            "invalid": "Molimo dodajte važeći Apple Music Url."
        },
        "beatport_url": {
            "required": "Beatport Url je obavezan",
            "invalid": "Molimo dodajte važeći Beatport Url."
        },
        "deezer_url": {
            "required": "Deezer Url je obavezan",
            "invalid": "Molimo dodajte važeći Deezer Url."
        },
        "junodownload_url": {
            "required": "Junodownload Url je obavezan",
            "invalid": "Molimo dodajte važeći Junodownload Url."
        },
        "soundcloud_url": {
            "required": "Soundcloud Url je obavezan",
            "invalid": "Molimo dodajte važeći Soundcloud Url."
        },
        "spotify_url": {
            "required": "Spotify Url je obavezan",
            "invalid": "Molimo dodajte važeći Spotify Url."
        },
        "tidal_url": {
            "required": "Tidal Url je obavezan",
            "invalid": "Molimo dodajte važeći Tidal Url."
        },
        "traxsource_url": {
            "required": "Traxsource Url je obavezan",
            "invalid": "Molimo dodajte važeći Traxsource Url."
        },
        "youtube_url": {
            "required": "Youtube Url je obavezan",
            "invalid": "Molimo dodajte važeći Youtube Url."
        },
        "anghami_url": {
            "required": "Anghami Url je obavezan",
            "invalid": "Molimo dodajte važeći Url."
        },
        "bandcamp_url": {
            "required": "Bandcamp Url je obavezan",
            "invalid": "Molimo dodajte važeći Url."
        },
        "boomplay_url": {
            "required": "Boomplay Url je obavezan",
            "invalid": "Molimo dodajte važeći Url."
        },
        "iheartradio_url": {
            "required": "iHeartRadio Url je obavezan",
            "invalid": "Molimo dodajte važeći Url."
        },
        "jiosaavn_url": {
            "required": "JioSaavn Url je obavezan",
            "invalid": "Molimo dodajte važeći Url."
        },
        "sevendigital_url": {
            "required": "7digital Url je obavezan",
            "invalid": "Molimo dodajte važeći Url."
        },
        "other_url": {
            "invalid": "Molimo dodajte važeći Url."
        },
        "pvTrackName": {
            "required": "Naziv pjesme je obavezan"
        },
        "pvArtistName": {
            "required": "Ime izvođača je obavezno"
        }
    }
};

export default musicLinksValidationHR;